<template>
  <div class="flexbox">
    <div class="flex-content">
      <div>
        <basic-select :options="options"
                      :selected-option="item"
                      @select="onSelect"
                      :is-disabled="isDisabled"
                      :show-missing-options="true"
                      :customAttr="customAttr">
        </basic-select>
      </div>
    </div>
    <div class="flex-result">
      <table class="ui celled table">
        <thead>
        <tr>
          <th>value</th>
          <th>text</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{item.value}}</td>
          <td>{{item.text}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { BasicSelect } from '../../lib'

  export default {
    data () {
      return {
        options: [
          { value: '1', text: 'aa' + ' - ' + '1' },
          { value: '2', text: 'ab' + ' - ' + '2' },
          { value: '3', text: 'bc' + ' - ' + '3' },
          { value: '4', text: 'cd' + ' - ' + '4' },
          { value: '5', text: 'de' + ' - ' + '5' },
          { value: '6', text: 'ef' + ' - ' + '6' },
          { value: '7', text: 'ef' + ' - ' + '7' },
          { value: '8', text: 'ef' + ' - ' + '8' },
          { value: '9', text: 'ef' + ' - ' + '9' },
          { value: '10', text: 'ef' + ' - ' + '10' },
          { value: '11', text: 'ef' + ' - ' + '11' },
          { value: '12', text: 'ef' + ' - ' + '12' }
        ],
        item: {
          value: 'missing',
          text: 'missing',
          missing: true
        },
        isDisabled: false
      }
    },
    methods: {
      onSelect (item) {
        this.item = item
      },
      selectOption () {
        // select option from parent component
        this.item = this.options[0]
      },
      customAttr (option) {
        if (option.missing) {
          return 'missing'
        }
        return ''
      }
    },
    components: {
      BasicSelect
    }
  }
</script>

<style>
.item[data-vss-custom-attr="missing"] {
  color: red !important;
}
.ui div.text[data-vss-custom-attr="missing"] {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// _WithMissing.vue?eefe8ae2